import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "new-add",
  "use": "new-add-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"new-add\"><path fill-rule=\"nonzero\" d=\"M11 9h7v2h-7v7H9v-7H2V9h7V2h2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol